module.exports = __webpack_public_path__ + "64dd9c44a2cb107688e344287e7c4bcd.png";